import { connect } from 'react-redux';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';

import { areElementsRounded } from 'shared/selectors/app-settings';

import Tag from './tag/tag';

import styles from './tags-cloud.styl';


@connect(state => ({
  isRounded: areElementsRounded(state),
}))
@WixConnect(styles)
export default class TagsCloud extends React.Component {
  static propTypes = {
    tags: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
    onTagFocus: React.PropTypes.func,
    onTagClick: React.PropTypes.func,
    onTagBlur: React.PropTypes.func,
    className: React.PropTypes.string,
    tagClassName: React.PropTypes.string,
    roundedTagClassName: React.PropTypes.string,
    isRounded: React.PropTypes.bool,
  };

  static defaultProps = {
    onTagClick: _.noop,
  };

  render() {
    const {
      tags, isRounded,
      className, tagClassName, roundedTagClassName,
      onTagClick, onTagFocus, onTagBlur,
    } = this.props;

    const classNames = classnames(styles.tag, tagClassName);

    return (
      <div className={className}
           styleName="tags-cloud">
        {
          _.map(tags, tag => (
            <Tag key={tag}
                 className={classNames}
                 roundedClassName={roundedTagClassName}
                 text={tag}
                 rounded={isRounded}
                 onClick={onTagClick}
                 onFocus={onTagFocus}
                 onBlur={onTagBlur} />
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/tags-cloud/tags-cloud.js